import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/kuwatataiga/Downloads/resume_truemee_backup/frontend/components/footer.tsx");
